import React from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          APSY SNBT - Assessment Prediction System SNBT
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
